import { PricingPlanType } from '../types/pricingPlans';

export interface PricingPlanConfig {
  name: string;
  description: string;
  features: string[];
  featuresNotIncluded: string[];
  note: string | null;
  price: string;
  themeColor: 'emerald' | 'blue' | 'purple' | 'orange';
  cssClasses: string;
  icon: 'zap' | 'store' | 'crown' | 'star';
  isInternal: boolean;
  maxBookingsPerWeek?: number;
  maxB2BOrdersPerMonth?: number;
  upgradeTo: PricingPlanType[];
}

export const PRICING_PLANS_CONFIG: Record<PricingPlanType, PricingPlanConfig> = {
  free: {
    name: 'pricing.free.name',
    description: 'pricing.free.description',
    features: [
      'pricing.free.features.everything',
      'pricing.free.features.bookings',
      'pricing.free.features.b2bLimit',
      'pricing.features.catalogues',
      'pricing.features.unlimited_accounts',
      'pricing.features.sms_reminders',
      'pricing.features.contract_signatures',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.priority_support',
      'pricing.features.custom_integrations'
    ],
    note: null,
    price: 'Free',
    themeColor: 'emerald',
    cssClasses: 'bg-emerald-100 text-emerald-800 border-emerald-300',
    icon: 'zap',
    isInternal: true,
    maxBookingsPerWeek: 5,
    maxB2BOrdersPerMonth: 3,
    upgradeTo: ['store', 'brand']
  },
  'early-adopter': {
    name: 'pricing.earlyAdopter.name',
    description: 'pricing.earlyAdopter.description',
    features: [
      'pricing.earlyAdopter.features.all',
      'pricing.earlyAdopter.features.bookings',
      'pricing.earlyAdopter.features.priority',
      'pricing.earlyAdopter.features.beta',
      'pricing.features.catalogues',
      'pricing.features.unlimited_accounts',
      'pricing.features.sms_reminders',
      'pricing.features.contract_signatures',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.custom_integrations',
    ],
    note: null,
    price: 'Free',
    themeColor: 'orange',
    cssClasses: 'bg-orange-100 text-orange-800 border-orange-300',
    icon: 'star',
    isInternal: true,
    maxBookingsPerWeek: 999,
    maxB2BOrdersPerMonth: 999,
    upgradeTo: ['store', 'brand']
  },
  store: {
    name: 'pricing.store.name',
    description: 'pricing.store.description',
    features: [
      'pricing.store.features.calendar',
      'pricing.store.features.orders',
      'pricing.store.features.contracts',
      'pricing.store.features.bookings',
      'pricing.features.priority_support',
      'pricing.store.features.more',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.custom_integrations',
    ],
    note: 'pricing.store.note',
    price: 'pricing.store.price',
    themeColor: 'blue',
    cssClasses: 'bg-blue-100 text-blue-800 border-blue-300',
    icon: 'store',
    isInternal: false,
    upgradeTo: ['brand', 'free']
  },
  brand: {
    name: 'pricing.brand.name',
    description: 'pricing.brand.description',
    features: [
      'pricing.brand.features.all',
      'pricing.brand.features.b2b',
      'pricing.brand.features.production',
      'pricing.brand.features.onsite',
      'pricing.features.advanced_analytics',
      'pricing.features.custom_integrations'
    ],
    featuresNotIncluded: [],
    note: 'pricing.brand.note',
    price: 'pricing.brand.price',
    themeColor: 'purple',
    cssClasses: 'bg-purple-100 text-purple-800 border-purple-300',
    icon: 'crown',
    isInternal: false,
    upgradeTo: ['free', 'store']
  }
};
